// extracted by mini-css-extract-plugin
module.exports = {"Spiner":"card_Spiner__3bNLj","HideSpiner":"card_HideSpiner__8Efik","Card":"card_Card__n1Pxe","To":"card_To__OlpsM","Amount":"card_Amount__2XW7L"};